<template>

  <div class="container-fluid text-left" style="margin-top:20px">
    <div class="row-fluid">

      <div class="span12">

        <div class="jumbotron bg_user" style="margin-bottom:10px;padding-top: 40px;padding-bottom: 40px;">
          <div class="container">
            <div class="row">
              <div class="col-2" style="margin-top:3px;margin-left:-10px">
                <img :src=img width="60" height="60" />
              </div>
              <div class="col-6">
                <div style="margin-left: 25px;">
                  <h4 style="color:#fffdff;">{{name | name}}</h4>
                </div>
                <!-- <div style="margin-left: 15px;">523 积分</div> -->
                <div v-if="state == 1">
                  <div style="margin-left: 25px;color:#fffdff;" v-if="key_id == 1"><span
                      class="label label-primary label_50"
                      style="border-radius: 50px/50px; background-color: #ffd986; color: #00a4b7;">V</span>群团组织</div>
                  <div style="margin-left: 25px;color:#fffdff;" v-if="key_id == 2"><span
                      class="label label-primary label_50"
                      style="border-radius: 50px/50px; background-color: #ffd986; color: #00a4b7;">V</span>社团组织</div>
                  <div style="margin-left: 25px;color:#fffdff;" v-if="key_id == 3"><span
                      class="label label-primary label_50"
                      style="border-radius: 50px/50px; background-color: #ffd986; color: #00a4b7;">V</span>个人用户</div>
                </div>
                <div v-else>
                  <div style="margin-left: 25px;color:#fffdff;">普通用户</div>
                </div>

              </div>
              <div class="col-4 text-right middle" @click="$router.push('/modifydata')">
                <span class="label label-default" style="padding: .5em .6em .3em;">修改资料</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h5 class="f_bt_1">基础模块</h5>
            <div class="row" style="height: 60px;">
              <div class="col-6" @click="$router.push('/server_project_release')" v-if="state==1">
                <div class="text-center bgbtn">
                  设置服务
                </div>
              </div>
              <div class="col-6" @click="$router.push('/server_user_release')" v-if="state!=1">
                <div class="text-center bgbtn">
                  用户认证
                </div>
              </div>
              <div class="col-6" @click="$router.push('/user_help_release')">
                <div class="text-center bgbtn1">
                  发布需求
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 row tt_x_10" style="padding-right:0px; padding-top: .8rem; border-bottom: 1px solid #eee;"
            @click="$router.push('/user_collection_list')">
            <div class="col-6">
              <h5 class="f_bt_1"><span class="	glyphicon glyphicon-heart glyphicon-a"></span> 我的收藏</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>
          </div>
          <div class="col-12 row tt_x_10" style="padding-right:0px;margin-top: .8rem;  border-bottom: 1px solid #eee;"
            @click="$router.push('/user_server_list')">
            <div class="col-6">
              <h5 class="f_bt_1"><span class="glyphicon glyphicon-send glyphicon-a"></span> 我的服务</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>
          </div>
          <div class="col-12 row tt_x_10" style="padding-right:0px; margin-top: .8rem; border-bottom: 1px solid #eee;"
            @click="$router.push('/user_help_list')">
            <div class="col-6">
              <h5 class="f_bt_1"><span class="glyphicon glyphicon-random glyphicon-a"></span> 我的需求</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>
          </div>
          <div class="col-12 row tt_x_10" style="padding-right:0px; margin-top: .8rem; border-bottom: 1px solid #eee;"
            @click="$router.push('/user_examine_list')" v-if="jurisdiction == 1">
            <div class="col-6">
              <h5 class="f_bt_1"><span class="glyphicon glyphicon-a"><img
                    src="https://img.hsnms.com/20210924/1632458771.png" width="16" height="19"
                    style="margin-top:-6px" /></span> 我的审核</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>
          </div>
          <div class="col-12 row tt_x_10" style="padding-right:0px; margin-top: .8rem;  border-bottom: 1px solid #eee;"
            v @click="$router.push('/user_tidings_list')">
            <div class="col-6">
              <h5 class="f_bt_1"><span class="glyphicon glyphicon-fire glyphicon-a"></span> 积分信息</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>
          </div>
          <div class="col-12 row tt_x_10" style="padding-right:0px; margin-top: .8rem;  border-bottom: 1px solid #eee;"
            @click="$router.push('/mall_list')">

            <div class="col-6">
              <h5 class="f_bt_1"><span class="glyphicon glyphicon-tree-deciduous glyphicon-a"></span> 积分商城</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>

          </div>

          <div class="col-12 row tt_x_10" style="padding-right:0px; margin-top: .8rem;  border-bottom: 1px solid #eee;"
            @click="$router.push('/user_order_list')">

            <div class="col-6">
              <h5 class="f_bt_1"><span class="glyphicon glyphicon-gift glyphicon-a"></span> 我的订单</h5>
            </div>
            <div class="col-6 text-right middle" style="padding-right:0px;">
              <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
            </div>
          </div>
        </div>
        <div style="height: 6.25rem;"></div>

      </div>

    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      img: '',
      name: '',
      integral: '',
      key_id: 0,
      jurisdiction: '',
      state: "",
    }
  },
  methods: {

  },
  mounted () {
    //console.log(this.$api.getUserInfo());
    this.$api.getAPI("mutual/attribute/0?appid=202108&type_id=4001", {
      openid: this.$api.getUserInfo().openid
      // openid: "8afac8196cbc454b016cbc9108f94b07"
    }).then(res => {

      // console.log(res);
      // this.$api.getUserInfo_updata("8afac8196cbc454b016cbc9108f94b07");
      // console.log(res.data.data.models);
      this.img = res.data.data.models.avatar_url
      // console.log(this.img);
      this.jurisdiction = res.data.data.models.jurisdiction
      this.name = res.data.data.models.username
      this.key_id = res.data.data.models.key_id;
      this.state = res.data.data.models.state;
    })


  },
  filters: {
    name (value) {
      if (!value) return '';
      let str = value;
      str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, '$1*$3')
      return str;
    }
  }
}
</script>

<style>
.bgbtn {
  color: #fffdff;
  padding: 14px 0px;
  font-size: 16px;
  background-image: linear-gradient(to right, #26b5bd, #62d8cb);
  border-radius: 10px 0 0 10px;
}

.bgbtn1 {
  color: #fffdff;
  padding: 14px 0px;
  font-size: 16px;
  background-image: linear-gradient(to right, #62d8cb, #26b5bd);
  border-radius: 0 10px 10px 0;
}

.jumbotron {
  padding-top: 30px;
  padding-bottom: 30px;
}

.f_bt_1 {
  font-size: 16px;
}

.m_a {
  padding-right: 0px;
  padding-left: 0px;
}

/* .label {
  padding: 0.3em 0.6em 0.3em;
} */
.bg_user {
  background: url("https://img.hsnms.com/20210922/1632279215.jpg") no-repeat
    center;
  background-size: 100% 100%;
  /* box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.4); */
}
</style>



// WEBPACK FOOTER //
// src/components/views/home_users.vue